export default "__VITE_ASSET__j7OfUJMM__"